/** Thrown when GET /users/me returns 404 (account deleted). */
export class AccountDeletedError extends Error {
  readonly status = 404;

  constructor(message = "ACCOUNT_DELETED") {
    super(message);
    this.name = "AccountDeletedError";
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export function isAccountDeletedError(e: unknown): e is AccountDeletedError {
  return e instanceof AccountDeletedError;
}
